<template>
  <div id="app" :class="{ 'modal-active': modalComponentShow }">
    <transition name="landing" appear mode="out-in">
      <router-view />
    </transition>
    <keep-alive>
      <modal-component></modal-component>
    </keep-alive>
    <keep-alive>
      <modal-alert></modal-alert>
    </keep-alive>
    <keep-alive>
      <modal-component-footer></modal-component-footer>
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalComponent from './components/common/ModalComponent.vue'
import ModalAlert from './components/common/ModalAlert.vue'
import ModalComponentFooter from './components/common/ModalAlertFooter'
import * as types from './store/mutation-types'
// let FB = window.FB
// let Sentry = window.Sentry

export default {
  name: 'app',
  components: {
    ModalComponentFooter,
    ModalComponent,
    ModalAlert
  },
  created() {
    // Sentry.init({
    //   dsn: 'https://4dd0827274e24de8814be5283d7df315@sentry.io/1474031'
    // })
    window.fbAsyncInit = function() {
      // eslint-disable-next-line no-undef
      FB.init({
        appId: '1523211691049666',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.10'
      })
    }
  },
  mounted() {
    ;(function(d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
    this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'on')
  },
  computed: {
    ...mapGetters(['modalComponentShow'])
  }
}
</script>
<style lang="scss">
#app {
  &.modal-active {
    animation: modalActive ease-in-out;
    animation-delay: 0.5s;
    animation-fill-mode: forwards;
  }

  @keyframes modalActive {
    from {
      position: relative;
    }

    to {
      position: fixed;
    }
  }
}

@font-face {
  font-family: 'Georgia';
  src: url('./assets/css/fonts/Georgia-Italic.woff2') format('woff2'),
    url('./assets/css/fonts/Georgia-Italic.woff') format('woff');
  font-weight: normal;
  font-style: italic;
}

@import url('https://fonts.googleapis.com/css?family=Poppins:200,600,800');
@import 'assets/css/animate.css';

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
  font-family: 'Poppins', sans-serif;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

.landing-enter-active {
  transition: all 0.2s ease;
}

.landing-leave-active {
  transition: all 0.2s ease-in-out;
}

.landing-leave-enter,
.landing-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transition: opacity 0.5s;
}
</style>
